export default "__VITE_ASSET__1u9NOyFU__"